import isUndefined from 'lodash/isUndefined.js';

const UNIT_FACTORS_MAP = {
  dp: 0.88,
  px: 1
};
function decimalAdjust(type, value, exp) {
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  value = value.toString().split('e');
  value = Math[type](+`${value[0]}e${value[1] ? +value[1] - exp : -exp}`);
  value = value.toString().split('e');
  return +`${value[0]}e${value[1] ? +value[1] + exp : exp}`;
}
function formatOutputValue(_ref) {
  let {
    value,
    precision = 0,
    unit
  } = _ref;
  if (!unit) {
    return value;
  }
  const outputValue = decimalAdjust('floor', value / (UNIT_FACTORS_MAP[unit] || 1), -precision);
  return `${outputValue}${unit}`;
}
function parseIncomingUnit(_ref2) {
  let {
    value
  } = _ref2;
  if (typeof value !== 'string') {
    return;
  }
  const unit = String(value).match(/[\d.\-\+]*\s*(.*)/)[1] || '';
  return unit;
}
function parseIncomingValue(_ref3) {
  let {
    value,
    precision = 0
  } = _ref3;
  if (typeof value !== 'string' || isUndefined(value)) {
    return value;
  }
  const str = String(value);
  const num = parseFloat(str, 10);
  const unit = str.match(/[\d.\-\+]*\s*(.*)/)[1] || '';
  if (UNIT_FACTORS_MAP[unit]) {
    return decimalAdjust('ceil', num * UNIT_FACTORS_MAP[unit], -precision);
  }
  return num;
}
function getPrecision(value) {
  if (isUndefined(value)) {
    return 0;
  }
  const valueString = value.toString();
  const dotPosition = valueString.indexOf('.');
  let precision = 0;
  if (dotPosition !== -1) {
    precision = valueString.length - dotPosition - 1;
  }
  return precision;
}
function toPrecision(num) {
  let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const precisionFactor = 10 ** precision;
  return parseFloat(Math.round(num * precisionFactor) / precisionFactor);
}
function decrease(val, step, numPrecision, currentValue) {
  if (typeof val !== 'number' && !isUndefined(val)) {
    return currentValue;
  }
  const precisionFactor = 10 ** numPrecision;
  return toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor, numPrecision);
}
function increase(val, step, numPrecision, currentValue) {
  if (typeof val !== 'number' && !isUndefined(val)) {
    return currentValue;
  }
  const precisionFactor = 10 ** numPrecision;
  return toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor, numPrecision);
}

export { decrease, formatOutputValue, getPrecision, increase, parseIncomingUnit, parseIncomingValue, toPrecision };
//# sourceMappingURL=utils.js.map
